
export const dollerToWisd = (doller) => {
    return doller/0.0016;
} 